import getEdgesForNodes from "Areas/Documents/graph/utils/getEdgesForNodes";
import morphLayout from "Areas/Documents/graph/utils/morphLayout";
import forEach from "lodash/forEach";
import uniq from "lodash/uniq";
import calculateDefaultNodeLayout from "./calculateDefaultNodeLayout";
import createEdge from "./createEdge";
import createNode from "./createNode";
export default (graphComponentRef, sourceData, layoutAlgorithmRef, setInProgress, beforeMorph, completed, rejected, animateViewport = true) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph))
        return false;
    setInProgress && setInProgress(true);
    const affectedNodes = new Set();
    const nodesMap = {};
    const defaultNodeLayout = calculateDefaultNodeLayout(graphComponentRef.current);
    forEach(sourceData.DocumentObjects, obj => {
        const node = createNode(graphComponentRef, obj, defaultNodeLayout);
        if (node) {
            nodesMap[obj.Id] = node;
            affectedNodes.add(node);
        }
    });
    forEach(sourceData.Transforms, tr => {
        var _a;
        const fromIds = uniq((_a = tr.Input) === null || _a === void 0 ? void 0 : _a.Types);
        const toIds = uniq(tr.Output);
        if ((fromIds === null || fromIds === void 0 ? void 0 : fromIds.length) && (toIds === null || toIds === void 0 ? void 0 : toIds.length)) {
            forEach(fromIds, fromId => {
                forEach(toIds, toId => {
                    createEdge(graphComponentRef, tr, nodesMap[fromId], nodesMap[toId]);
                });
            });
        }
    });
    const affectedEdges = getEdgesForNodes(graphComponentRef, affectedNodes, true);
    if (affectedNodes.size || affectedEdges.size) {
        beforeMorph && beforeMorph();
        morphLayout(graphComponentRef, layoutAlgorithmRef, affectedNodes, affectedEdges, setInProgress, () => {
            completed && completed();
        }, () => {
            rejected && rejected();
        }, animateViewport, "0s");
    }
    else {
        setInProgress && setInProgress(false);
        completed && completed();
    }
    return true;
};
